import { jsx as _jsx } from "react/jsx-runtime";
import { reduceBreakLines } from "@smp/utils";
import { forwardRef, useCallback, useEffect, useRef, } from "react";
export const ContentEditableDiv = forwardRef((props, ref) => {
    const localRef = useRef(null);
    const divRef = ref || localRef;
    const handleInput = useCallback((e) => {
        if (props.onChange) {
            props.onChange(e);
        }
    }, [props]);
    useEffect(() => {
        const currentValue = divRef.current && reduceBreakLines(divRef.current.innerText);
        if (divRef.current && currentValue !== props.value) {
            divRef.current.innerText = props.value;
        }
    }, [divRef, props.value]);
    return (_jsx("div", { ref: divRef, contentEditable: true, suppressContentEditableWarning: true, className: props.className, onInput: handleInput }));
});
//# sourceMappingURL=content_editable_div.js.map